import { LoadingButton } from '@mui/lab';
import { Box, CardContent, Grid, TextField, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { api } from 'src/Api';
import Alert from '@mui/material/Alert';

export default function DeliveryFeeModal({ handleClose, Deliveryproduct, refreshAdmin }) {
  const [minproduct, setMinProduct] = useState('');
  const [maxproduct, setMaxProduct] = useState('');
  const [fixedprice, setFixedPrice] = useState('');
  const [loading, setloading] = useState('');
  const [alert, setalert] = useState({ visible: false, message: '' });

  function AddDeliveryFee() {
    setloading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    formdata.append('min_product', minproduct);
    formdata.append('max_product', maxproduct);
    formdata.append('price', fixedprice);

    Deliveryproduct && formdata.append('id', Deliveryproduct?.id);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    fetch(Deliveryproduct ? api.edit_delivery_fee : api.add_delivery_fee, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }

  useEffect(() => {
    if (Deliveryproduct) {
      setMinProduct(Deliveryproduct?.min_product);
      setMaxProduct(Deliveryproduct?.max_product);
      setFixedPrice(Deliveryproduct?.price);
    }
  }, []);

  useEffect(() => {
    setalert({ visible: false, message: '' });
  }, [minproduct, maxproduct]);

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t(Deliveryproduct ? 'Edit Delivery fee' : 'Add Delivery fee')}
      </Typography>
      <CardContent>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Min Product'}
                type="text"
                value={minproduct}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value == '') {
                    setMinProduct(value);
                  }
                  if (/^\d*$/.test(value) && parseInt(value) <= 100) {
                    // Ensure only numbers and max value is 100
                    setMinProduct(value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Max Product'}
                type="text"
                value={maxproduct}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value == '') {
                    setMaxProduct(value);
                  }
                  if (/^\d*$/.test(value) && parseInt(value) <= 100) {
                    // Ensure only numbers and max value is 100
                    setMaxProduct(value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Price (LKR)'}
                type="text" // Change type to text to control input
                value={fixedprice}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // Allow only numbers
                    setFixedPrice(value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>
          </>
        </Grid>
        <Box mt={2} />
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </CardContent>
      <Box></Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            if (parseInt(maxproduct) < parseInt(minproduct)) {
              setalert({
                visible: true,
                message:
                  'The value in the Min Product field cannot be greater than the value in the Max Product field'
              });
            } else {
              AddDeliveryFee();
            }
          }}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          Cancel
        </LoadingButton>
      </Box>
    </Box>
  );
}
